module.exports = __webpack_public_path__ + "_/_/_/node_modules/@reverbdotcom/discovery-ui/images/products/blank_medium-c75c80e41b39b5a41afdd4927af311a2.jpg";


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/images/products/blank_medium.jpg
// module id = H2o8
// module chunks = 22 24 25